// extracted by mini-css-extract-plugin
export default {"noResults":"NoResults_noResults__8MOXz"};